/**
 * Default payment method types returned by
 * `GET/PUT/DELETE /api/users/me/default-payment-method` and the SetupIntent
 * endpoints. Kept separate from `payment-model.tsx` (which models charge
 * payments) because tap-to-charge needs a card-on-file with no PaymentIntent.
 */

export interface PaymentMethodSummary {
  brand: string;
  last4: string;
  exp_month: number;
  exp_year: number;
}

export interface DefaultPaymentMethodResponse {
  default_payment_method: PaymentMethodSummary | null;
  payment_method_id?: string;
}

export interface SetupIntentResponse {
  client_secret: string;
  setup_intent_id: string;
}

export const formatCardBrand = (brand: string | null | undefined): string => {
  if (!brand) return 'Card';
  const lowered = brand.toLowerCase();
  switch (lowered) {
    case 'visa':
      return 'Visa';
    case 'mastercard':
      return 'Mastercard';
    case 'amex':
    case 'american_express':
      return 'American Express';
    case 'discover':
      return 'Discover';
    case 'diners':
    case 'diners_club':
      return 'Diners Club';
    case 'jcb':
      return 'JCB';
    case 'unionpay':
      return 'UnionPay';
    default:
      return brand.charAt(0).toUpperCase() + brand.slice(1);
  }
};

export const formatExpiry = (
  month: number | null | undefined,
  year: number | null | undefined,
): string => {
  if (!month || !year) return '';
  const mm = String(month).padStart(2, '0');
  const yy = String(year).slice(-2);
  return `${mm}/${yy}`;
};
